export enum ApiRoles {
  SUPER_ADMIN = 1,
  CUSTOMER_ADMIN = 2,
  CUSTOMER_PILOT = 3,
  CUSTOMER_PLANT_MANAGER = 4,
  OPERATOR = 5,
  SALESPERSON = 6,
  CUSTOMER_VIEWER = 7,
  ADMIN = 9,
  CUSTOMER_OWNER = 10,
}